
import PageBar from "../../components/dashboard/page-bar/PageBar";
import AddNewJobType from "../../components/job-types/addNewJobType/AddnewJobType";
function AddNewJobTypesPage() {
  return (
    <>
      <PageBar title=" Add Job Type" />
      <AddNewJobType />
    </>
  );
}
export default AddNewJobTypesPage;
